import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';

export const PropCheckInputWrapper = styled.div`
  margin-top: 32px;
`;

export const StyledInput = styled.input`
  visibility: hidden;
  position: absolute;

  :not(:checked) + label::after {
    opacity: 0;
    transform: scale(0);
  }
`;

export const InputInnerLabel = styled.label`
  font-size: 18px;
  max-width: 410px;
  font-weight: 300;
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  line-height: 32px;
  display: inline-block;
  color: ${palette.footerBackground};
  transition: all .2s ease;

  &:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    width: 32px;
    height: 32px;
    border: 2px solid ${palette.proBlue};
    border-radius: 100%;
    background: ${palette.white};
  }

  &:after {
    content: "";
    width: 32px;
    height: 32px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 100%;
    transition: all .2s ease;
    background-color: ${palette.proBlue};
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMiI+PHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNC45NjQgOS40MDlMMS4yNTggNS43MDIgMCA2Ljk2bDQuOTY0IDQuOTY0TDE1LjYzMSAxLjI1OCAxNC4zNzMgMHoiLz48L3N2Zz4=);
    background-size: 60%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

export const InputsContainer = styled.div`
  display: flex;

  > div:first-child {
    margin-right: 50px;
  }
`;

export const InputWrapper = styled.div`
  display: inline-block;
  margin-top: 6px;

  @media screen and (min-width: ${layout.sm}) {
    margin-right: 50px;
  }
`;
